import AttachFile from "@mui/icons-material/AttachFile";
import {
  Button,
  Dialog,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  Autocomplete,
  DialogTitle,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  FormControlLabel,
} from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import colors from "../components/constants/Colors";

const Partners = () => {
  const [name, setName] = useState("");
  const [pic, setPic] = useState("");
  const [logo, setLogo] = useState(null);
  const [rows, setRows] = useState([]);
  const [allPartners, setAllPartners] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState({});
  const [partnersInProject, setPartnersInProject] = useState([]);
  const [selectedName, setSelectedName] = useState("");
  const [selectedPic, setSelectedPic] = useState("");
  const [manualEntry, setManualEntry] = useState(false);

  const project_id = localStorage.getItem("project_id");

  const maxLength = 10;

  const handleFileChange = (event) => {
    setLogo(event.target.files[0]);
  };

  const addPartner = async () => {
    if (!name) {
      Swal.fire(
        "Validation Error",
        "Please fill out all required fields",
        "warning"
      );
      return;
    }

    const formData = new FormData();
    formData.append("name", name.toUpperCase());
    formData.append("pic", pic);
    if (logo) {
      formData.append("logo", logo);
    }

    try {
      const response = await axios.post(
        ` https://eutracker.rdiup.com/v1/partners/create/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201) {
        Swal.fire("Success", "Partner added successfully!", "success");
        setName("");
        setPic("");
        setLogo(null);
        if (project_id && project_id != null) {
          getPartnersInProject();
        } else {
          fetchAllPartners();
        }
      }
    } catch (error) {
      console.error("There was an error adding the partner!", error);

      let errorMessage = "An unexpected error occurred. Please try again.";

      if (error.response && error.response.data) {
        const errorDetails = error.response.data.details || {};
        const formattedErrors = Object.entries(errorDetails)
          .map(([field, messages]) => {
            return messages.map((msg) => `${field}: ${msg}`).join("<br>");
          })
          .join("<br>");

        errorMessage = formattedErrors || errorMessage;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        html: errorMessage, // Use 'html' to handle multi-line error messages
      });
    }
  };

  // Function to add a partner
  // const addPartnerInProject = async () => {
  //     // Validate input
  //     if (!name || !pic) {
  //         Swal.fire('Validation Error', 'Please fill out all required fields', 'warning');
  //         return;
  //     }

  //     // Create FormData object
  //     const formData = new FormData();
  //     formData.append('name', name.toUpperCase());
  //     formData.append('pic', pic);
  //     if (logo) {
  //         formData.append('logo', logo);
  //     }

  //     try {
  //         // Send POST request to add partner
  //         const response = await axios.post(` https://eutracker.rdiup.com/v1/projects/${project_id}/add_partner/`, formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data',
  //             },
  //         });

  //         if (response.status === 201) {
  //             Swal.fire('Success', 'Partner added successfully!', 'success');
  //             // Clear form fields
  //             setName('');
  //             setPic('');
  //             setLogo(null);
  //             // Fetch updated list of partners
  //             if(project_id && project_id != null){
  //                 getPartnersInProject();
  //             }else{
  //                 fetchAllPartners();
  //             }
  //         }
  //     } catch (error) {
  //         console.error('There was an error adding the partner!', error);

  //         // Prepare error message
  //         let errorMessage = 'An unexpected error occurred. Please try again.';

  //         if (error.response && error.response.data) {
  //             const errorDetails = error.response.data.details || {};
  //             const formattedErrors = Object.entries(errorDetails).map(([field, messages]) => {
  //                 return messages.map(msg => `${field}: ${msg}`).join('<br>');
  //             }).join('<br>');

  //             errorMessage = formattedErrors || errorMessage;
  //         }

  //         // Show error message
  //         Swal.fire({
  //             icon: 'error',
  //             title: 'Error',
  //             html: errorMessage,  // Use 'html' to handle multi-line error messages
  //         });
  //     }
  // };

  const addPartnerInProject = async () => {
    // Create FormData object
    const formData = new FormData();
    formData.append("name", manualEntry ? name : selectedName.toUpperCase());
    formData.append("pic", manualEntry ? pic : selectedPic);

    if (logo) {
      formData.append("logo", logo);
    }

    try {
      const response = await axios.post(
        ` https://eutracker.rdiup.com/v1/projects/${project_id}/add_partner/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        Swal.fire("Success", "Partner added successfully!", "success");
        setName("");
        setPic("");
        setLogo(null);

        if (project_id) {
          getPartnersInProject();
        } else {
          fetchAllPartners();
        }
      }
    } catch (error) {
      console.error("There was an error adding the partner!", error);

      let errorMessage = "An unexpected error occurred. Please try again.";

      if (error.response && error.response.data) {
        const errorDetails = error.response.data.error || {};
        errorMessage = errorDetails;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage, // Use 'text' if there's no HTML content
      });
    }
  };

  const getPartnersInProject = async () => {
    try {
      // Make GET request to fetch partners for the given project
      const response = await axios.get(
        ` https://eutracker.rdiup.com/v1/projects/${project_id}/get_partners/`
      );

      if (response.status === 200) {
        // Successfully fetched partners
        const partners = response.data;
        setRows(response.data);
        // You can process the partners data here, e.g., update your state or UI
        return partners; // Return the data for further use if needed
      }
    } catch (error) {
      console.error("There was an error fetching partners!", error);

      // Prepare error message
      let errorMessage = "An unexpected error occurred. Please try again.";

      if (error.response && error.response.data) {
        const errorDetails = error.response.data.details || {};
        const formattedErrors = Object.entries(errorDetails)
          .map(([field, messages]) => {
            return messages.map((msg) => `${field}: ${msg}`).join("<br>");
          })
          .join("<br>");

        errorMessage = formattedErrors || errorMessage;
      }
    }
  };

  useEffect(() => {
    const getPartners = async () => {
      try {
        const response = await axios.get(
          ` https://eutracker.rdiup.com/v1/partners/`
        );
        setAllPartners(
          response.data.map((partner) => ({
            id: partner.id,
            name: partner.name,
            pic: partner.pic,
            imageURL: partner.imageURL,
          }))
        );
      } catch (err) {
        console.log("Failed to fetch partners");
        console.error(err);
      }
    };
    getPartners();
  }, []);

  const fetchAllPartners = async () => {
    try {
      const response = await axios.get(
        ` https://eutracker.rdiup.com/v1/partners/`
      );
      setRows(response.data.map((partner) => ({ id: partner.id, ...partner })));
      console.log("response partners", response.data);
      setAllPartners(
        response.data.map((partner) => ({
          id: partner.id,
          name: partner.name,
          pic: partner.pic,
          imageURL: partner.imageURL,
        }))
      );
    } catch (err) {
      console.log("Failed to fetch partners");
      console.error(err);
    }
  };

  useEffect(() => {
    if (
      (project_id && project_id != null) ||
      localStorage.getItem("is_admin") == false
    ) {
      getPartnersInProject();
    } else {
      fetchAllPartners();
    }
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedPartner({});
  };

  const handleEditClick = (id) => () => {
    const selectedRow = rows.find((row) => row.id === id);
    setSelectedPartner(selectedRow);
    setOpenDialog(true);
  };

  const handleDeleteClick = (id) => async () => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this partner? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          ` https://eutracker.rdiup.com/v1/projects/${project_id}/partners/delete/${id}/`
        );
        if (response.status === 204) {
          Swal.fire("Deleted!", "Partner has been deleted.", "success");
          setRows((prevRows) => prevRows.filter((row) => row.id !== id));
        }
      } catch (error) {
        console.error("There was an error deleting the partner!", error);
        Swal.fire("Error", "There was an error deleting the partner.", "error");
      }
    } else {
      // Optional: Add a message or action if the user cancels the deletion
      Swal.fire("Cancelled", "", "info");
    }
  };
  const handleSaveClick = async () => {
    if (!selectedPartner.name) {
      Swal.fire(
        "Validation Error",
        "Please fill out all required fields",
        "warning"
      );
      return;
    }
    handleCloseDialog();

    // Show confirmation dialog before updating
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this partner's information?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      const formData = new FormData();
      formData.append("name", selectedPartner.name.toUpperCase());
      formData.append("pic", selectedPartner.pic || "");

      if (logo) {
        formData.append("logo", logo);
      }

      try {
        const response = await axios.put(
          ` https://eutracker.rdiup.com/v1/partners/update/${selectedPartner.id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          Swal.fire("Success", "Partner updated successfully!", "success");
          if (project_id && project_id != null) {
            getPartnersInProject();
          } else {
            fetchAllPartners();
          }
        }
      } catch (error) {
        console.error("There was an error updating the partner!", error);

        let errorMessage = "An unexpected error occurred. Please try again.";
        if (error.response && error.response.data) {
          const errorDetails = error.response.data.details || {};
          errorMessage = errorDetails.name
            ? errorDetails.name[0]
            : errorMessage;
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      }
    } else {
      // Optional: Inform the user that the update was canceled
      Swal.fire("Cancelled", "The partner update was canceled.", "info");
    }
  };

  const columns = [
    { field: "name", headerName: "Partner", width: 150, editable: false },
    {
      field: "imageURL",
      headerName: "",
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <img
            src={params.value}
            alt="logo"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "80px",
              maxHeight: "50px",
              objectFit: "contain",
              marginTop: 10,
            }}
          />
        ) : (
          "N/A"
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            key="edit"
            icon={<EditIcon />}
            label="Edit"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            key="delete"
            icon={<DeleteIcon />}
            onClick={handleDeleteClick(id)}
            label="Delete"
            color="inherit"
          />,
        ];
      },
    },
  ];

  console.log("selected name", selectedName);
  console.log("selected pic", selectedPic);

  const renderAutocomplete = () => {
    return (
      <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 10 }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          style={{ display: manualEntry ? "none" : "block" }}
        >
          <FormControl fullWidth>
            <Autocomplete
              options={allPartners}
              getOptionLabel={(option) => `${option.name} (${option.pic})`}
              renderInput={(params) => (
                <TextField {...params} label="Add existing partner" />
              )}
              onChange={(event, value) => {
                if (value) {
                  setSelectedName(value.name);
                  setSelectedPic(value.pic);
                } else {
                  setSelectedName("");
                  setSelectedPic("");
                }
              }}
              fullWidth
              size="small"
            />
          </FormControl>
        </Grid>

        {/* <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={manualEntry}
                            onChange={() => setManualEntry(!manualEntry)}
                        />
                    }
                    label="I want to add new partner"
                />
            </Grid> */}

        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.secondary }}
            onClick={project_id ? addPartnerInProject : addPartner}
            disabled={!name && !selectedPic}
            fullWidth
            style={{ marginTop: 0, marginBottom: 0 }}
          >
            Add partner
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid style={{ marginBottom: 50 }}>
      <Grid container>
        <p style={{ fontSize: 18, fontWeight: "600", color: colors.secondary }}>
          Define partners
        </p>
      </Grid>
      <Grid container>
        <FormControlLabel
          control={
            <Checkbox
              checked={manualEntry}
              onChange={() => setManualEntry(!manualEntry)}
            />
          }
          label="I want to add new partner"
        />
      </Grid>
      <br />

      {!manualEntry ? (
        renderAutocomplete()
      ) : (
        <Grid
          container
          spacing={2}
          alignItems="center"
          sx={{ marginBottom: 10 }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>
                  Name{" "}
                  <span style={{ fontSize: 12, color: colors.primary }}>
                    (Short name)
                  </span>
                </span>
              </div>
              <TextField
                type="text"
                placeholder="RDIUP"
                inputProps={{ maxLength: 10 }}
                value={name}
                onChange={(e) => setName(e.target.value)}
                size="small"
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 10,
                  right: 30,
                  fontSize: 12,
                  color: colors.primary,
                  width: 60,
                  height: 20,
                  pointerEvents: "none",
                  backgroundColor: "white",
                }}
              >
                {maxLength - name.length} chars
              </div>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>
                  PIC Number{" "}
                  <span style={{ fontSize: 12, color: colors.primary }}></span>
                </span>
              </div>
              <TextField
                type="text"
                placeholder="Pic number"
                inputProps={{ maxLength: 10 }}
                value={pic}
                onChange={(e) => setPic(e.target.value)}
                size="small"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>Logo</span>
              </div>
              <TextField
                size="small"
                type="file"
                variant="outlined"
                onChange={handleFileChange}
                InputProps={{
                  inputProps: {
                    accept: "image/*",
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachFile />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Button
              variant="contained"
              sx={{ backgroundColor: colors.secondary }}
              onClick={
                project_id && project_id != null
                  ? addPartnerInProject
                  : addPartner
              }
              disabled={!name || !pic}
              fullWidth
              style={{ marginTop: 20, marginBottom: 0 }}
            >
              Add partner
            </Button>
          </Grid>
        </Grid>
      )}

      <div style={{ height: 300, width: "60%" }}>
        <Grid
          sx={{
            backgroundColor: colors.primary,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            marginTop: -5,
          }}
        >
          <Typography gutterBottom sx={{ color: "white" }}>
            List of partners who contributed to this project
          </Typography>
        </Grid>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          paginationMode="client"
          onPageChange={(params) => setPage(params.page)}
          pagination
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 3 },
            },
          }}
          pageSizeOptions={[5, 10, 20]}
          sx={{ mt: -0.7 }}
        />
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Edit Partner</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Edit the partner details. Currently editing: {selectedPartner?.name}
          </DialogContentText>

          <FormControl fullWidth>
            <div style={{ textAlign: "left" }}>
              <span>
                Name{" "}
                <span style={{ fontSize: 12, color: colors.primary }}>
                  (Short name) *
                </span>
              </span>
            </div>
            <TextField
              fullWidth
              type="text"
              placeholder="RDIUP"
              value={selectedPartner?.name || ""}
              onChange={(e) =>
                setSelectedPartner({ ...selectedPartner, name: e.target.value })
              }
              sx={{ width: 250, height: 40 }}
              size="small"
            />
          </FormControl>
          <br />
          <FormControl fullWidth>
            <div style={{ textAlign: "left" }}>
              <span>PIC Number</span>
            </div>
            <TextField
              fullWidth
              type="text"
              placeholder="PIC"
              value={selectedPartner?.pic || ""}
              onChange={(e) =>
                setSelectedPartner({ ...selectedPartner, pic: e.target.value })
              }
              sx={{ width: 250, height: 40 }}
              size="small"
            />
          </FormControl>
          <FormControl fullWidth>
            <div style={{ textAlign: "left" }}>
              <span>Logo</span>
            </div>
            <TextField
              size="small"
              type="file"
              variant="outlined"
              onChange={handleFileChange}
              InputProps={{
                inputProps: {
                  accept: "image/*",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachFile />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleSaveClick}
            sx={{ backgroundColor: colors.secondary }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Partners;
